// extracted by mini-css-extract-plugin
export default {"backBtn":"Back_backBtn__5dbgm"};